import { createVNode as t, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FolderOpenFilled.js";
import p from "../components/PfIcon.js";
const e = (r, o) => {
  const l = {
    ...r,
    ...o.attrs
  };
  return t(p, i(l, {
    icon: n
  }), null);
};
e.displayName = "FolderOpenFilled";
e.inheritAttrs = !1;
export {
  e as default
};
